import { render, staticRenderFns } from "./accountList.vue?vue&type=template&id=8208c194&scoped=true&"
import script from "./accountList.vue?vue&type=script&lang=js&"
export * from "./accountList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8208c194",
  null
  
)

export default component.exports